<template>
  <div class="third register-api-details">
    <div class="third-formOne">
      <div class="formOne-btn">
        <div class="btn-left">
          <span class="left-back-icon" @click="changeComponent">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>
          <span class="left-back-content">服务配置》{{currentName}}</span>
        </div>
        <div class="btn-right">
          <el-button @click="resetForm" class="btn-two" type="default">重置</el-button>
          <el-button @click="commit" class="btn-two" type="primary" v-el-disabel-repeat-click>保存</el-button>
        </div>
      </div>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="86px"
        @validate="validateValue"
        :show-message="false"
      >
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">基本信息</span>
              </div>
            </div>
            <div class="one-list">
              <el-form-item label="卡片展示名称" prop="showName">
                <el-input
                  class="list-input"
                  :maxlength="8"
                  v-model.trim="ruleForm.showName"
                  placeholder="请输入"
                ></el-input>
                <span></span>
              </el-form-item>
              <el-form-item label="卡片顺序" prop="orderNum">
                <el-input
                  class="list-input"
                  :maxlength="20"
                  v-model.trim="ruleForm.orderNum"
                  placeholder="请输入"
                  :disabled="true"
                ></el-input>
              </el-form-item>
              <el-form-item label="公众号消息集合" prop="openAll">
                <el-radio-group v-model="ruleForm.openAll">
                  <el-radio label="1">展示</el-radio>
                  <el-radio label="2">隐藏</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="公众号消息集合标签位置" prop="homeRow" v-if="ruleForm.openAll === '1'">
                <el-radio-group v-model="ruleForm.homeRow">
                  <el-radio :label="1">公众号卡片之前</el-radio>
                  <el-radio :label="2">公众号卡片之后</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">详细资讯卡片</span>
              </div>
            </div>
            <div class="one-list">
              <div class="add-row">
                <el-button icon="el-icon-plus" @click="openAddDialog"
                  >新增公众号卡片</el-button
                >
                <span
                  >加上全部，建议同时启用4个公众号卡片，最多9个，点击拖动单元格可变更公众号卡片顺序</span
                >
              </div>
              <div class="list-four-line">
                <el-table
                  class="third-tableThree"
                  :data="currentTableData"
                  border
                  stripe
                >
                  <el-table-column
                    prop="serviceName"
                    label="名称"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                    prop="accountSubject"
                    label="账号主体"
                    :show-overflow-tooltip="true"
                  ></el-table-column>
                  <el-table-column
                    prop="mpType"
                    label="公众号性质"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="{ row }">
                      <span>{{
                        row.mpType === "4" ? "部门号" : "订阅号"
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="example"
                    label="卡片状态"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="{ row }">
                      <span
                        :style="{
                          color: row.openStatus === '1' ? '#33CC99' : '#FF4D4F',
                        }"
                        >{{
                          row.openStatus === "1" ? "已开启" : "已关闭"
                        }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="state"
                    label="操作"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="small"
                        @click="updateStatus(scope.row, scope.$index)"
                      >
                        {{ scope.row.openStatus !== "1" ? "开启" : "关闭" }}
                      </el-button>
                      <span class="tableThree-height-shu">
                        <span class="shu-item"></span>
                      </span>
                      <el-button
                        type="text"
                        size="small"
                        @click="deleteRowConfirm(scope.row, scope.$index)"
                        :disabled="scope.row.editStatus === 'ALL'"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <notice-modal
      :noticeModalVisible="noticeModal"
      @noticeModalClose="closeNotice"
      @noticeModalAgree="agreeNotice"
      :noticeTitle="noticeTitle"
      :noticeSpec="noticeSpec"
      :noticeType="noticeType"
      :btnAgree="agreeContent"
      :noticeContent="noitceContent"
    >
    </notice-modal>
    <addOfficalAccounts
      :addModalVisible="addModalVisible"
      @closeAddModal="closeAddModal"
      :choosedList="currentTableData"
      @addData="addData"
    ></addOfficalAccounts>
  </div>
</template>

<script>
import { itemDetailPort, updatePort } from '@/api/appSetting/appServiceSetting'
import Sortable from 'sortablejs';
import addOfficalAccounts from '../component/addOfficalAccounts'
import { uniqBy } from 'lodash'
export default {
  name: "formSeven",
  props: ['rowId'],
  data () {
    return {
      currentName:'',
      countNum: 1, //用于显示第一个错误
      addModalVisible: false,
      cpRowId: this.rowId,
      //   &********弹框******************************
      agreeNotice: {},
      noticeType: 1, // 提示类型
      agreeContent: '确定', // 提示弹窗确认按钮内容
      noticeTitle: '提示', // 提示
      noitceContent: '确定启用删除吗？', // 提示信息
      noticeModal: false, // 提示弹窗
      noticeSpec: '', // 标红提示
      //   &**************************************
      ruleForm: {
        id: "",
        showName: '',
        orderNum: '',
        homeRow: 1,
        serviceList: []
      },
      rules: {
        orderNum: [
          { required: true, message: "请输入卡片顺序", trigger: "blur" },
        ],
        showName: [{ required: false, message: "请输入展示名称", trigger: "blur" }],
        homeRow: [{ required: true, message: "请选择公众号消息集合展示位置", trigger: "change" }],
        openAll: [{ required: true, message: "请选择公众号消息集合", trigger: "change" }]
      },
      currentTableData: []
    };
  },
  components: {
    addOfficalAccounts
  },
  created () {
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
    this.itemDetail()
    // this.serviceBusDetail();
  },
  mounted () {
    this.$nextTick(() => {
      this.rowDrop()
    })
  },
  watch: {
    rowId () {
      this.cpRowId = this.rowId
    },
    // currentTableData() {
    //   this.$nextTick(() => {
    //     this.rowDrop()
    //   })
    // }
  },
  methods: {
    // 验证
    validateValue(prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    // 提交表单
    commit() {
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.ruleForm.validate(valid => {
          console.log("valid", valid);
          if (valid) {
            this.countNum = 1;
            this.updateData()
          } else {
            return false;
          }
        });
      });
    },
    //表单重置
    resetForm() {
      this.$refs.ruleForm.clearValidate()
      this.$nextTick(() => {
        this.itemDetail()
      })
    },
    async updateData () {
      console.log('this.cpRowId', this.ruleForm.accessWay)
      const serviceList = [...this.currentTableData].map((el, index) => {
        return {
          openStatus: el.openStatus,
          orderNum: index,
          serviceId: el.serviceId
        }
      })
      const {
        data: {
          result, msg, status
        }
      } = await updatePort({
        ...this.ruleForm,
        serviceList
      })
      if (status === 1000) {
        this.$message.success('操作成功')
        this.changeComponent()
        console.log('结果', result)
        return
      }
      return this.$message.error(msg)
    },
    deleteRowConfirm (rowData, index) {
      // this.agreeNotice = () => {
      //   this.noticeModal = false
      //   this.deleteRow(index)
      // }
      // this.noticeModal = true
      this.deleteRow(index)
    },
    deleteRow (index) {
      this.currentTableData.splice(index, 1)
    },
    updateStatus (rowData, index) {
      if (rowData.openStatus === '1') {
        this.$set(this.currentTableData[index], 'openStatus', '2')
        return
      }
      this.$set(this.currentTableData[index], 'openStatus', '1')
    },
    addData (list) {
      console.log(list)
      // this.currentTableData = uniqBy([...this.currentTableData,...list],'serviceId')
      const oldList = [...this.currentTableData]
      const resolveData = []
      const temporaryOldList = []
      list.forEach((newData, index) => {
        const isHaveData = oldList.find(oldData => {
          return oldData.serviceId === newData.serviceId
        })
        if (isHaveData !== undefined) {
          console.log('isHaveData', isHaveData)
          temporaryOldList.push(isHaveData)
        } else {
          resolveData.push(newData)
        }
      })
      resolveData.reverse()
      console.log('resolveData', resolveData)
      this.currentTableData = [...resolveData,...temporaryOldList]
      this.closeAddModal()
    },
    closeAddModal () {
      this.addModalVisible = false
    },
    openAddDialog () {
      this.addModalVisible = true
    },
    //行拖拽
    rowDrop () {
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      const _this = this
      Sortable.create(tbody, {
        onEnd ({ newIndex, oldIndex }) {
          const currRow = _this.currentTableData.splice(oldIndex, 1)[0]
          _this.currentTableData.splice(newIndex, 0, currRow)
          const newList = [..._this.currentTableData]
          _this.currentTableData = []
          _this.$nextTick(() => {
            _this.currentTableData = [...newList]
          })
          console.log('_this.currentTableData', _this.currentTableData)
        }
      })
    },
    async itemDetail () {
      console.log('this.cpRowId', this.cpRowId)
      const {
        data: {
          result, msg, status
        }
      } = await itemDetailPort({
        id: this.rowId
      })
      if (status === 1000) {
        this.currentName = result.itemName
        this.ruleForm = result
        this.currentTableData = [...result.serviceList]
        console.log('结果', result)
        return
      }
      return this.$message.error(msg)
    },
    // 关闭弹窗
    closeNotice () {
      this.noticeModal = false
    },
    // 复制地址
    copyUrl (url, params) {
      let copy = (e) => {
        e.preventDefault()
        e.clipboardData.setData('text/plain', url + params)
        this.$message.success('操作成功')
        document.removeEventListener('copy', copy)
      }
      document.addEventListener('copy', copy)
      document.execCommand('copy')
    },
    // 改变index页面的component的值
    changeComponent () {
      this.$emit("changeComponent", 'homePage');
    },
  }
};
</script>
<style lang="scss">
.register-api-details {
  .multi-rows,
  .single-row {
    display: inline-block;
    font-size: 12px;
    padding-left: 8px;
    color: #828d9a;
  }
  .add-row {
    margin-bottom: 15px;
    font-size: 12px;
    color: rgb(46, 63, 87);
    .el-button {
      margin-left: 0 !important;
      margin-right: 10px;
    }
  }
  .rows-copy {
    padding-left: 8px;
    color: #2d8cf0;
    cursor: pointer;
  }
  .single-row {
    min-width: 292px;
  }
  .row-goto {
    color: #2d8cf0;
    cursor: pointer;
  }
  .multi-rows {
    width: 676px;
  }
}
</style>
